import { datadogRum } from '@datadog/browser-rum';
import Cookies from 'js-cookie';
import accessToken from '|/helpers/access-token';

declare global {
  interface Window {
    DD_RUM?: typeof datadogRum;
  }
}

const CAR_MERCH_PREFIX = 'car-merch';

/**
 * Extracts all cookies with the car-merch_ prefix
 */
export function getCarMerchCookies(): Record<string, string> {
  const allCookies = Cookies.get() ?? {};
  return Object.entries(allCookies).reduce(
    (acc, [key, value]) => {
      if (key.startsWith(CAR_MERCH_PREFIX)) {
        acc[key] = value;
      }
      return acc;
    },
    {} as Record<string, string>
  );
}

// Set car-merch experiment cookies as global context
const carMerchCookies = getCarMerchCookies();
if (Object.keys(carMerchCookies).length > 0) {
  datadogRum.setGlobalContextProperty('carMerchExperiments', carMerchCookies);
}

const COOKIES = {
  dataDogSampling: '_dd_s'
};

function checkIsSampled(): boolean {
  const samplingCookie = Cookies.get(COOKIES.dataDogSampling);
  return !samplingCookie || samplingCookie.includes('rum=0') || samplingCookie.includes('rum=2');
}

if (checkIsSampled()) {
  Cookies.remove(COOKIES.dataDogSampling);
}

datadogRum.init({
  applicationId: 'bc7fb6cc-d24a-48c8-9722-f2ce30b35402',
  clientToken: 'pub6bf64308e6574813f395ad9a5c3f2c98',
  env: process.env.NODE_ENV,
  site: 'datadoghq.com',
  service: 'purchase-ui',
  version: process.env.APP_VERSION,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  trackUserInteractions: true,
  trackResources: true,
  actionNameAttribute: 'data-analytics-id',
  defaultPrivacyLevel: 'mask-user-input',
  trackViewsManually: true,
  beforeSend: (event, context) => {
    try {
      if (event.type === 'resource' && 'xhr' in context) {
        const { xhr = null } = context;
        const correlationIdArray = xhr?.headers?.['correlation-id'] ?? [];
        const correlationId = (correlationIdArray.length && correlationIdArray[0]) || null;
        if (correlationId) {
          event.context = {
            ...event.context,
            correlationId
          };
        }
      }
      if (event.type === 'error' && event.error.source === 'console') {
        const isChatUiError = event.error.handling_stack?.includes('googleapis');
        event.context = {
          ...event.context,
          isChatUiError
        };
      }
      if (
        event.type === 'error' &&
        event.error.fingerprint === 'v11.F22CBEFAF5D7D41601AFCFAE02AB4C0D'
      ) {
        return false;
      }
    } catch (e) {
      console.error(e);
    }
    return true;
  }
});

datadogRum.setUser({
  // must use id since datadog's queryable columns are not dynamic
  id: accessToken().user.user_id,
  userBcid: Cookies.get('BrowserCookieId')
});

datadogRum.startSessionReplayRecording();

window.DD_RUM = datadogRum;
